import React, { useEffect, useState } from "react";
import LocationInfo from "../../../Components/Providers/LocationInfo";
import LocationsTd from "./LocationsTd";
import LocationstrHeader from "./LocationstrHeader";
import ReactPaginate from "react-paginate";
import toast from "react-hot-toast";
import CustomTable from "../../../Components/Common/CustomTable";
import { LocationFrom } from "./LocationsData";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLocations,
  getLocation,
} from "../../../redux/locations/locationSlice";
import { useSearchParams } from "react-router-dom";
import { IoLocationOutline } from "react-icons/io5";
import Loader from "../../../Components/Common/Loader";
const Locations = ({ showForm, toggleCreateProviderForm }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const [sortBy, setSortBy] = useState("createdAt");
  const [order, setOrder] = useState("desc");
  const { location, locations, totalPages, deletError, fetchStatus } =
    useSelector((state) => state.locations);

  const dispatch = useDispatch();
  const handlePageClick = ({ selected }) => {
    localStorage.setItem("currentPage", selected + 1);
    setCurrentPage(selected + 1);
  };

  const [locationFormData, setLocationFormData] = useState({
    displayName: "",
    name: "",
    phoneNumber: "",
    dialCode: "+91",
    address1: "",
    address2: "",
    country: "",
    zipCode: "",
    city: "",
    state: "",
    HfrId1: "",
    HfrId2: "",
  });
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  useEffect(() => {
    dispatch(fetchLocations({ currentPage, itemsPerPage, sortBy, order }));
    // eslint-disable-next-line
  }, [currentPage, itemsPerPage, sortBy, order, id]);

  useEffect(() => {
    if (id) {
      if(!showForm){
        toggleCreateProviderForm()
      }
      dispatch(getLocation(id));
    } // eslint-disable-next-line
    else {
      if (showForm) {
        toggleCreateProviderForm();
      }
    }
  }, [id]);

  useEffect(() => {
    if (location) {
      const {
        name = "",
        address: {
          addressLine1 = "",
          addressLine2 = "",
          country = "",
          city = "",
          zipCode = "",
          state = "",
        } = {},
        phoneNumber: { dialCode = "+91", value = "" } = {},
        displayName = "",
        HfrId = "",
      } = location;

      setLocationFormData({
        name,
        phoneNumber: value,
        dialCode,
        displayName,
        address1: addressLine1,
        address2: addressLine2,
        country,
        city,
        zipCode,
        state,
        HfrId1: HfrId,
        HfrId2: HfrId,
      });
    }
  }, [location]);

  function handleSortClick(field) {
    setSortBy(field);
    setCurrentPage(1);
  }

  function handleOrderClick(order) {
    setOrder(order);
    setCurrentPage(1);
  }

  if (deletError === "failed") {
    return toast.error(deletError);
  }

  if (showForm) {
    return (
      <div className="w-full h-full">
        <LocationInfo
            setLocationFormData={setLocationFormData}
            locationFormData={locationFormData}
            UserBasicInfo={LocationFrom.UserBasicInfo}
            toggleCreateProviderForm={toggleCreateProviderForm}
            id={id}
            showForm={showForm}
            setCurrentPage={setCurrentPage}
          />
      </div>
    );
  }

  // Render locations list
  return (
      <div className="overflow-x-auto w-full h-full sm:rounded-lg">
        {fetchStatus ? (
            <Loader />
        ) : locations && locations.length > 0 ? (
          <>
            <CustomTable
              trHeader={
                <LocationstrHeader
                  sortBy={sortBy}
                  order={order}
                  setSortBy={handleSortClick}
                  setOrder={handleOrderClick}
                />
              }
            >
              <LocationsTd
                toggleCreateProviderForm={toggleCreateProviderForm}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </CustomTable>
            <ReactPaginate
              previousLabel={"«"}
              nextLabel={"»"}
              breakLabel={"..."}
              pageCount={totalPages}
              onPageChange={handlePageClick}
              forcePage={currentPage - 1}
              containerClassName={"flex justify-center mt-6 mb-0"}
              pageClassName={"mx-1"}
              pageLinkClassName={
                "block px-4 py-2 rounded hover:bg-brand-600 hover:text-white"
              }
              previousClassName={"mx-1"}
              previousLinkClassName={
                "block px-3 py-2 rounded bg-slate-100 hover:bg-brand-600 hover:text-white"
              }
              nextClassName={"mx-1"}
              nextLinkClassName={
                "block px-3 py-2 rounded bg-slate-100 hover:bg-brand-600 hover:text-white"
              }
              activeClassName={"bg-brand-500 text-white rounded"}
              activeLinkClassName={"border-none"}
            />
          </>
        ) : (
          <div className="w-full h-full flex justify-center items-center">
            <div className="flex flex-col items-center justify-center min-h-[300px] text-center p-6">
              <IoLocationOutline className="h-20 w-20 text-brand-500 mb-4" />
              <h2 className="text-2xl font-semibold text-gray-700 mb-2">
                No locations available
              </h2>
              <p className="text-gray-500 mb-4">
                Please add a new location to manage and view them here.
              </p>
            </div>
          </div>
        )}
      </div>
    
  );
};

export default Locations;
